import { ClientConfig } from '../../config/ClientConfig'

let cachedProfilingPromise: Promise<string> | undefined

export const rmpProfilingPage = () => {
    if (cachedProfilingPromise) return cachedProfilingPromise

    cachedProfilingPromise = new Promise((resolve) => {
        const { RMP_PROFILING_SCRIPT_URL, RMP_RISK_ASSESSMENT_KEY } = ClientConfig
        const src = `${RMP_PROFILING_SCRIPT_URL}/${RMP_RISK_ASSESSMENT_KEY}`
        const rmpScript = document.createElement('script')
        rmpScript.type = 'text/javascript'
        rmpScript.async = false
        rmpScript.addEventListener('load', () => {
            window.rmp.collectAsync().then((rawProfilingBundle) => {
                resolve(rawProfilingBundle)
            })
        })
        rmpScript.addEventListener('error', () => {
            console.error('RMP script failed to load')
            resolve(undefined)
        })
        rmpScript.src = src
        document.head.appendChild(rmpScript)
    })

    return cachedProfilingPromise
}
